import { action } from "typesafe-actions";
import {
	IGeneralHistory,
	IMail,
	IPolicies,
	IRecordCount,
	IReporteeReferrals,
} from "./common.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import {
	closeLoaderWithMessage,
	openLoaderWithMessage,
	saveLoaderCompleted,
	saveLoaderProgress,
	showMessage,
} from "../messages/messagesActions";
import { api } from "../../api/api";
import { LoadState } from "../../constants/enums";
import { IFileUpload } from "../../components/FileUpload/FileUpload.type";
import { IDate } from "../../components/Table/hooks/useDateFilter";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { formatDate, formatDate2, getUserAuth } from "../../helpers";
import { FETCH_REPORTEE_REFERRALS_FAILURE, FETCH_REPORTEE_REFERRALS_PROGRESS, FETCH_REPORTEE_REFERRALS_SUCCESS } from "../../constants/constants";

export const FETCH_POLICIES_PROGRESS = "FETCH_POLICIES_PROGRESS";
export const FETCH_POLICIES_SUCCESS = "FETCH_POLICIES_SUCCESS";
export const FETCH_POLCIES_FAILED = "FETCH_POLCIES_FAILED";

export const fetchPoliciesProgress = () => action(FETCH_POLICIES_PROGRESS);
export const fetchPoliciesSuccess = (policies: IPolicies[]) =>
	action(FETCH_POLICIES_SUCCESS, { policies });
export const fetchPoliciesFailed = () => action(FETCH_POLCIES_FAILED);
export const fetchPolicies =
	(): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			const policies = getState().common.policies;
			if (policies.loadState !== LoadState.Loaded) {
				try {
					dispatch(fetchPoliciesProgress());
					const res = await api.get(`/policy/get-policies`);
					const data: IPolicies[] = res.data.data;

					dispatch(fetchPoliciesSuccess(data));
				} catch (err: any) {
					dispatch(
						showMessage({
							type: "error",
							message: err.response.data.message,
							displayAs: "snackbar",
						})
					);
					dispatch(fetchPoliciesFailed());
				}
			}
		};

export const fetchInitialRefData =
	(): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			dispatch(fetchPolicies());
		};

export const sendMessageToUserPhone =
	(
		data: {
			mobileNumber: string;
			message: string;
		},
		onCallback: (isSuccess: boolean) => void
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			try {
				await api.post(`/general/send-sms`, {
					recipients: [
						{
							to: "+1" + data.mobileNumber,
							name: data.message,
						},
					],
				});
				dispatch(
					showMessage({
						type: "success",
						message: "Message send successfully!",
						displayAs: "snackbar",
					})
				);

				onCallback(true);
			} catch (err: any) {
				onCallback(true);
				dispatch(
					showMessage({
						type: "error",
						message: err.response.data.message,
						displayAs: "snackbar",
					})
				);
			}
		};


export const fetchReporteeReferralsProgress = () =>
	action(FETCH_REPORTEE_REFERRALS_PROGRESS);
export const fetchReporteeReferralsSuccess = (data: IReporteeReferrals[]) =>
	action(FETCH_REPORTEE_REFERRALS_SUCCESS, { data });
export const fetchErrorAny = () => action(FETCH_REPORTEE_REFERRALS_FAILURE);



export const fetchReporteeReferralsAsync =
	(managerId?: number | null): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			const userDetails = getUserAuth();

			// try {
			// 	let newParams = "";
			// 	if (userDetails && userDetails.tokens) {
			// 		const userId = userDetails.user_id;
			// 		dispatch(fetchReporteeReferralsProgress());

			// 		if (userDetails.role !== userRoles.CXO) {
			// 			const id = managerId ?? userId;
			// 			newParams = "reporting_manager_id=" + id;
			// 		}
			// 		const res = await api.get(`/get-reportee?${newParams}`, {
			// 			headers: {
			// 				"auth-Token": userDetails.tokens.access,
			// 			},
			// 		});

			// 		const leadsList: IReporteeReferrals[] = res.data;

			// 		console.log(leadsList);

			// 		dispatch(fetchReporteeReferralsSuccess(leadsList));
			// 	}
			// } catch (err) {
			// 	dispatch(fetchSFAError());
			// }
		};

export const sendMessageToWhatsapp =
	(
		data: {
			mobileNumber: string;
			message: string;
		},
		onCallback: (isSuccess: boolean) => void
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			try {
				await api.post(`/general/send-whatsapp`, {
					recipients: [
						{
							to: "+1" + data.mobileNumber,
							name: data.message,
						},
					],
				});
				dispatch(
					showMessage({
						type: "success",
						message: "Message send successfully!",
						displayAs: "snackbar",
					})
				);

				onCallback(true);
			} catch (err: any) {
				onCallback(true);
				dispatch(
					showMessage({
						type: "error",
						message: err.response.data.message,
						displayAs: "snackbar",
					})
				);
			}
		};

export const sendVoiceCalling =
	(
		data: {
			mobileNumber: string;
		},
		onCallback: (isSuccess: boolean) => void
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			try {
				await api.post(`/general/voice-calling`, {
					recipients: [
						{
							to: "+1" + data.mobileNumber,
						},
					],
				});
				dispatch(
					showMessage({
						type: "success",
						message: "Voice calling is send successfully!",
						displayAs: "snackbar",
					})
				);

				onCallback(true);
			} catch (err: any) {
				onCallback(true);
				dispatch(
					showMessage({
						type: "error",
						message: err.response.data.message,
						displayAs: "snackbar",
					})
				);
			}
		};

export const sendEmail =
	(
		data: IMail,
		attachments: IFileUpload[],
		onCallback: (isSuccess: boolean) => void
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			try {
				dispatch(saveLoaderProgress());
				const finalData = { ...data };

				if (attachments.length > 0) {
					const keys: string[] = [];
					for (const attachment of attachments) {
						if (attachment.path) {
							keys.push(attachment.path);
						}
					}
					const bufferJson = await api.post("/general/download-files", {
						type: "json",
						keys,
					});
					finalData.attachments = bufferJson?.data?.map(
						(ele: any, index: number) => ({
							content: ele,
							filename: keys[index].split("/").at(-1),
						})
					);
				}

				await api.post(`/general/send-grid-email`, {
					...finalData,
				});
				dispatch(
					showMessage({
						type: "success",
						message: "Email is send successfully!",
						displayAs: "snackbar",
					})
				);

				onCallback(true);
			} catch (err: any) {
				onCallback(true);
				dispatch(
					showMessage({
						type: "error",
						message: err.response.data.message,
						displayAs: "snackbar",
					})
				);
			} finally {
				dispatch(saveLoaderCompleted());
			}
		};

export const FETCH_GENERAL_HISTORY_LIST_PROGRESS =
	"FETCH_GENERAL_HISTORY_LIST_PROGRESS";
export const FETCH_GENERAL_HISTORY_LIST_SUCCESS =
	"FETCH_GENERAL_HISTORY_LIST_SUCCESS";
export const FETCH_GENERAL_HISTORY_LIST_FAILED =
	"FETCH_GENERAL_HISTORY_LIST_FAILED";

export const fetchGeneraHistoryListProgress = () =>
	action(FETCH_GENERAL_HISTORY_LIST_PROGRESS);
export const fetchGeneraHistoryListSuccess = (data: IGeneralHistory[]) =>
	action(FETCH_GENERAL_HISTORY_LIST_SUCCESS, { data });
export const fetchGeneraHistoryListFailed = () =>
	action(FETCH_GENERAL_HISTORY_LIST_FAILED);

export const fetchGeneraHistoryListAsync =
	(
		customerPolicyId: number,
		tableName: string
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			try {
				dispatch(fetchGeneraHistoryListProgress());
				const res = await api.get(
					`/general/get-log-data?table_name=${tableName}&customer_policy_id=${customerPolicyId}`
				);

				const data: IGeneralHistory[] = res.data.data;
				if (data) {
					dispatch(fetchGeneraHistoryListSuccess(data));
				} else {
					dispatch(fetchGeneraHistoryListSuccess([]));
				}
			} catch (err: any) {
				dispatch(fetchGeneraHistoryListFailed());
				dispatch(
					showMessage({
						type: "error",
						message: err.response.data.message,
						displayAs: "snackbar",
					})
				);
			}
		};

export const fetchHistoryByTableColumnAsync =
	(
		module_code: string | number
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			try {
				dispatch(fetchGeneraHistoryListProgress());
				const res = await api.get(
					`/history/get-history?module_uuid=${module_code}`
				);

				const data: IGeneralHistory[] = res.data.data;
				if (data) {
					dispatch(fetchGeneraHistoryListSuccess(data));
				} else {
					dispatch(fetchGeneraHistoryListSuccess([]));
				}
			} catch (err: any) {
				dispatch(fetchGeneraHistoryListFailed());
				dispatch(
					showMessage({
						type: "error",
						message: err.response.data.message,
						displayAs: "snackbar",
					})
				);
			}
		};
export const CLEAR_GENERAL_HISTORY_STATE = "CLEAR_GENERAL_HISTORY_STATE";

export const clearGeneraHistoryState = () =>
	action(CLEAR_GENERAL_HISTORY_STATE);

export const FETCH_RECORD_COUNTS_PROGRESS = "FETCH_RECORD_COUNTS_PROGRESS";
export const FETCH_RECORD_COUNTS_SUCCESS = "FETCH_RECORD_COUNTS_SUCCESS";
export const FETCH_RECORD_COUNTS_FAILED = "FETCH_RECORD_COUNTS_FAILED";

export const fetchRecordsCountsProgress = () =>
	action(FETCH_RECORD_COUNTS_PROGRESS);
export const fetchRecordsCountsSuccess = (data: IRecordCount[]) =>
	action(FETCH_RECORD_COUNTS_SUCCESS, { data });
export const fetchRecordsCountsFailed = () =>
	action(FETCH_RECORD_COUNTS_FAILED);

export const fetchRecordCountsAsync =
  (
    tableName: string,

    fromDate?: string,
    toDate?: string,
    companyOutlet?: string,
    searchValue?: IDatatableV2AdvancedSearchFilter
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchRecordsCountsProgress());
      let query = "";
      if ((searchValue?.length ?? 0) > 0) {
        query = `&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      // if (searchValue.length > 0) {
      // 	url += `&advanceFilter=${JSON.stringify(searchValue)}`;
      // }

      if (companyOutlet) {
        query += `&company_outlet_uuid=${companyOutlet}`;
      }

      const res = await api.get(
        `/general/get-record-counts?table_name=${tableName}&duration_type=ALL_TIMES&from_date=${fromDate}&to_date=${toDate}` +
          query
      );

      const data: IRecordCount[] = res.data.data;

      dispatch(fetchRecordsCountsSuccess(data || []));
    } catch (err: any) {
      dispatch(fetchRecordsCountsFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const CLEAR_RECORD_COUNTS = "CLEAR_RECORD_COUNTS";
export const clearRecordCounts = () => action(CLEAR_RECORD_COUNTS);



export const FETCH_RECORD_COUNTS_PROGRESS_V2 = "FETCH_RECORD_COUNTS_PROGRESS_V2";
export const FETCH_RECORD_COUNTS_SUCCESS_V2 = "FETCH_RECORD_COUNTS_SUCCESS_V2";
export const FETCH_RECORD_COUNTS_FAILED_V2 = "FETCH_RECORD_COUNTS_FAILED_V2";

export const fetchRecordsCountsProgressV2 = () =>
	action(FETCH_RECORD_COUNTS_PROGRESS_V2);
export const fetchRecordsCountsSuccessV2 = (data: IRecordCount[]) =>
	action(FETCH_RECORD_COUNTS_SUCCESS_V2, { data });
export const fetchRecordsCountsFailedV2 = () =>
	action(FETCH_RECORD_COUNTS_FAILED_V2);

export const fetchRecordCountsAsyncV2 =
	(
		tableName: string,

		fromDate?: string,
		toDate?: string,
		columnNmae?: string,
		companyOutlet?: string,
		searchValue?: IDatatableV2AdvancedSearchFilter
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			try {
				dispatch(fetchRecordsCountsProgressV2());
				let query = "";
				if ((searchValue?.length ?? 0) > 0) {
					query = `&advanceFilter=${JSON.stringify(searchValue)}`;
				}
				// if (searchValue.length > 0) {
				// 	url += `&advanceFilter=${JSON.stringify(searchValue)}`;
				// }
				if (columnNmae) {
					query += `&column_name=${columnNmae}`;
				}

				if (fromDate) {
					query += `&from_date=${fromDate}`;
				}
				if (toDate) {
					query += `&to_date=${toDate}`;
				}
				if (companyOutlet) {
					query += `&company_outlet_uuid=${companyOutlet}`;
				}
				const res = await api.get(
					`/general/get-record-counts-cross?table_name=${tableName}` + query
				);

				const data: IRecordCount[] = res.data.data;

				dispatch(fetchRecordsCountsSuccessV2(data || []));
			} catch (err: any) {
				dispatch(fetchRecordsCountsFailedV2());
				dispatch(
					showMessage({
						type: "error",
						message: err.response.data.message,
						displayAs: "snackbar",
					})
				);
			}
		};

export const CLEAR_RECORD_COUNTS_V2 = "CLEAR_RECORD_COUNTS_V2";
export const clearRecordCountsV2 = () => action(CLEAR_RECORD_COUNTS_V2);


export const fetchDocumentList =
	(
		data: {
			pdfType: string;
			organizations_uuid?: string;
			courses_uuid?: string;
			searchValue?: IDatatableV2AdvancedSearchFilter;
			date?: IDate;
		},
		onCallback: (isSuccess: boolean, data: any) => void
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			try {
				dispatch(openLoaderWithMessage("Downloading Your FIle, Please wait..."));

				let url = "";

				if (data.organizations_uuid) {
					url += `&organizations_uuid=${data.organizations_uuid}`;
				}
				if (data.courses_uuid) {
					url += `&courses_uuid=${data.courses_uuid}`;
				}
				if (data.searchValue !== undefined && data.searchValue.length > 0) {
					url += `&advanceFilter=${JSON.stringify(data.searchValue)}`;
				}

				if (data.date) {
					url += `&from_date=${data.date.fromDate}&to_date=${data.date.toDate}`;
				}

				let finalUrl = `customer/get-inquiryList-pdf?pdfType=${data.pdfType}${url}`;

				const res = await api.get(finalUrl, {
					responseType: "arraybuffer",
				});

				const blob = new Blob([res.data], { type: "application/pdf" });

				// Create a temporary URL for the Blob
				const get_url = window.URL.createObjectURL(blob);

				// Create a link element and simulate a click to trigger the download
				const link = document.createElement("a");
				link.href = get_url;
				link.setAttribute("download", "FeeReceipt.pdf"); // Set the filename for the downloaded file
				document.body.appendChild(link);
				link.click();

				// Clean up by revoking the URL object
				window.URL.revokeObjectURL(get_url);
				document.body.removeChild(link);
				if (res.status === 200) {
					onCallback(true, res.data.data);
				}
			} catch (error: any) {
				dispatch(
					showMessage({
						type: "error",
						displayAs: "snackbar",
						message: error.message,
					})
				);
			} finally {
				dispatch(closeLoaderWithMessage());
			}
		};

export const FETCH_MODULES_LIST_PROGRESS = "FETCH_MODULES_LIST_PROGRESS";
export const FETCH_MODULES_LIST_SUCCESS = "FETCH_MODULES_LIST_SUCCESS";
export const FETCH_MODULES_LIST_FAILED = "FETCH_MODULES_LIST_FAILED";

export const fetchModulesListProgress = (isView: boolean) =>
	action(FETCH_MODULES_LIST_PROGRESS, { isView });
export const fetchModulesListSuccess = (data: string[], isView: boolean) =>
	action(FETCH_MODULES_LIST_SUCCESS, {
		data,
		isView,
	});
export const fetchModulesListFailed = (isView: boolean) =>
	action(FETCH_MODULES_LIST_FAILED, {
		isView,
	});

export const fetchModuleAsync =
	(
		tableType: "VIEW" | "BASE TABLE",
		companyOutlet?: string,
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			const isView = tableType === "VIEW";
			try {
				const modules = getState().common.modules;
				let isAlreadyFetched = false;
				if (isView) {
					isAlreadyFetched = modules.tableViews.loading === LoadState.Loaded;
				} else {
					isAlreadyFetched = modules.tableNames.loading === LoadState.Loaded;
				}
				if (!isAlreadyFetched) {
					dispatch(fetchModulesListProgress(isView));
					let url =
						"/general/get-table-name-or-column-name?table_type=" + tableType;
					if (companyOutlet) {
						url += `&company_outlet_uuid=${companyOutlet}`;
					}
					const res = await api.get(url);
					dispatch(fetchModulesListSuccess(res.data.data as string[], isView));
				}
			} catch (err: any) {
				dispatch(fetchModulesListFailed(isView));
				dispatch(
					showMessage({
						type: "error",
						message: err.response.data.message,
						displayAs: "snackbar",
					})
				);
			}
		};

export const fetchColumnsByTableNameAsync =
	(
		tableType: "VIEW" | "BASE TABLE",
		tableName: string,
		onCallback: (columns: string[]) => void,
		companyOutlet?: string,
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			try {
				let url =
					"/general/get-table-name-or-column-name?table_type=" +
					tableType +
					"&table_name=" +
					tableName;
				if (companyOutlet) {
					url += `&company_outlet_uuid=${companyOutlet}`;
				}
				const res = await api.get(url);
				onCallback(res.data.data);
			} catch (err: any) {
				dispatch(
					showMessage({
						type: "error",
						message: err.response.data.message,
						displayAs: "snackbar",
					})
				);
			}
		};

// ==================== FAULT TYPES ACTIONS ====================
export const FETCH_FAULT_TYPE_PROGRESS = "FETCH_FAULT_TYPE_PROGRESS";
export const FETCH_FAULT_TYPE_SUCCESS = "FETCH_FAULT_TYPE_SUCCESS";
export const FETCH_FAULT_TYPE_FAILED = "FETCH_FAULT_TYPE_FAILED";

export const fetchFaultTypeProgress = () => action(FETCH_FAULT_TYPE_PROGRESS);
export const fetchFaultTypeSuccess = (vehicleType: string, list: any[]) =>
	action(FETCH_FAULT_TYPE_SUCCESS, { vehicleType, list });
export const fetchFaultTypeFailed = () => action(FETCH_FAULT_TYPE_FAILED);

export const fetchFaultTypeAsync =
	(vehicleType: string = "FOUR_WHEELER"): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch) => {
			try {
				dispatch(fetchFaultTypeProgress());
				const res = await api.get(`/general/get-fault-type?vehicle_type=${vehicleType}`);
				const data = res.data?.data || res.data || [];
				dispatch(fetchFaultTypeSuccess(vehicleType, Array.isArray(data) ? data : []));
			} catch (err) {
				dispatch(fetchFaultTypeFailed());
			}
		};

export const FETCH_FAULT_NAME_PROGRESS = "FETCH_FAULT_NAME_PROGRESS";
export const FETCH_FAULT_NAME_SUCCESS = "FETCH_FAULT_NAME_SUCCESS";
export const FETCH_FAULT_NAME_FAILED = "FETCH_FAULT_NAME_FAILED";

export const fetchFaultNameProgress = () => action(FETCH_FAULT_NAME_PROGRESS);
export const fetchFaultNameSuccess = (key: string, list: any[]) =>
	action(FETCH_FAULT_NAME_SUCCESS, { key, list });
export const fetchFaultNameFailed = () => action(FETCH_FAULT_NAME_FAILED);

export const fetchFaultNameAsync =
	(vehicleType: string = "FOUR_WHEELER", faultType: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch) => {
			const key = `${vehicleType}-${faultType}`;
			try {
				dispatch(fetchFaultNameProgress());
				const res = await api.get(`/general/get-fault-name?vehicle_type=${vehicleType}&fault_type=${faultType}`);
				const data = res.data?.data || res.data || [];
				dispatch(fetchFaultNameSuccess(key, Array.isArray(data) ? data : []));
			} catch (err) {
				dispatch(fetchFaultNameFailed());
			}
		};

export const FETCH_FAULT_SUB_TYPE_PROGRESS = "FETCH_FAULT_SUB_TYPE_PROGRESS";
export const FETCH_FAULT_SUB_TYPE_SUCCESS = "FETCH_FAULT_SUB_TYPE_SUCCESS";
export const FETCH_FAULT_SUB_TYPE_FAILED = "FETCH_FAULT_SUB_TYPE_FAILED";

export const fetchFaultSubTypeProgress = () => action(FETCH_FAULT_SUB_TYPE_PROGRESS);
export const fetchFaultSubTypeSuccess = (key: string, list: any[]) =>
	action(FETCH_FAULT_SUB_TYPE_SUCCESS, { key, list });
export const fetchFaultSubTypeFailed = () => action(FETCH_FAULT_SUB_TYPE_FAILED);

export const fetchFaultSubTypeAsync =
	(vehicleType: string = "FOUR_WHEELER", faultType: string, faultName: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch) => {
			const key = `${vehicleType}-${faultType}-${faultName}`;
			try {
				dispatch(fetchFaultSubTypeProgress());
				const res = await api.get(`/general/get-fault-sub-type?vehicle_type=${vehicleType}&fault_type=${faultType}&fault=${faultName}`);
				const data = res.data?.data || res.data || [];
				dispatch(fetchFaultSubTypeSuccess(key, Array.isArray(data) ? data : []));
			} catch (err) {
				dispatch(fetchFaultSubTypeFailed());
			}
		};

